import urljoin from 'url-join';
import { stringify } from 'query-string';
import Configuration from '../../configuration/index.js';

export const cdnUrl = (path) => urljoin(Configuration.get('cdn_url'), path);

export const siteUrl = (path, sourceUrl = Configuration.get('site_url'), siteLanguage = Configuration.get('site_language')) => {
  if (siteLanguage) {
    return urljoin(sourceUrl, siteLanguage, path);
  }

  return urljoin(sourceUrl, path);
};

export function normalizeUrl(url, params = {}) {
  const queryParams = stringify((params || {}));

  return url + (queryParams ? `?${queryParams}` : '');
}

export function parseUrlPattern(pattern, params) {
  let reducedPath = pattern;

  const patternRegex = /:(?:([\w]+))/gi;
  const usedInUrl = {};
  const notUsed = { ...params };

  if (patternRegex.test(pattern)) {
    const matches = pattern.match(patternRegex);
    matches.forEach((match) => {
      const param = match.replace(':', '');
      if (params.hasOwnProperty(param)) {
        reducedPath = reducedPath.replace(`:${param}`, params[param]);
        usedInUrl[param] = params[param];
        delete notUsed[param];
      }
    });
  }

  return {
    url: reducedPath,
    params: {
      usedInUrl,
      notUsed
    }
  };
}
